/**
 * Resolves whether preferred-drug fields are required for a selected query
 * reason.
 *
 * @module isUserInputRequired
 */

import { ReasonModel } from "../../../../data-model/reasonModel";

/**
 * Returns whether preferred-drug fields are required for the selected query
 * reason.
 *
 * @param reason - Selected query reason text from the dropdown, if any.
 * @param queryReasons - Organization query reasons loaded from Firestore.
 * @returns `true` when the matched reason has `should_show_user_input`
 *   set to `"required"`.
 */
export const isUserInputRequired = (
  reason: string | null,
  queryReasons: ReasonModel[],
): boolean => {
  if (!reason) {
    return false;
  }

  const userInputRequirement = queryReasons.find(
    (reasonItem) => reasonItem.reason === reason,
  )?.should_show_user_input;

  return userInputRequirement === "required";
};
